import api from "./api.js";

export default class ChapterApi {
  // ---------- 대제목 ---------- //
  static async createChapterTitle(data) {
    return await api.post(`api/chapter-title`, data);
  }

  static async getListChapterTitle(params) {
    return await api.get(`api/chapter-title`, params);
  }

  static async getByIdChapterTitle(chapterTItleId, params) {
    return await api.get(`api/chapter-title/${chapterTItleId}`, params);
  }

  static async updateChapterTitle(data) {
    return await api.patch(`api/chapter-title/`, data);
  }

  static async deleteChapterTitle(chapterTItleId, params) {
    return await api.del(`api/chapter-title/${chapterTItleId}`, params);
  }

  // ---------- 소제목(목차) ---------- //
  static async createChapter(data) {
    return await api.post(`api/chapter`, data);
  }

  static async getListChapter(params) {
    return await api.get(`api/chapter`, params);
  }

  static async getByIdChapter(chapterId, params) {
    return await api.get(`api/chapter/${chapterId}`, params);
  }

  static async updateChapter(chapterId, data) {
    return await api.patch(`api/chapter/${chapterId}`, data);
  }

  static async updateActivationChapter(chapterId, data) {
    return await api.patch(`api/chapter/activation/${chapterId}`, data);
  }

  static async deleteChapter(chapterId, params) {
    return await api.del(`api/chapter/${chapterId}`, params);
  }

  static async updateOrderChapter(chapterId, data) {
    return await api.patch(`api/chapter/order/${chapterId}`, data);
  }
}
